"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicContentItemDataSchema = void 0;
const yup = __importStar(require("yup"));
exports.dynamicContentItemDataSchema = yup.object({
    data: yup.object({
        dateInitial: yup
            .date()
            .required()
            .test('is-after-now', 'dateInitial deve ser menor ou igual à data atual', function (value) {
            if (!value)
                return false;
            const now = new Date();
            const dateInitialStart = new Date(value);
            dateInitialStart.setHours(0, 0, 0, 0);
            return dateInitialStart <= now;
        }),
        dateFinal: yup
            .date()
            .required()
            .test('is-before-now', 'dateFinal deve ser maior ou igual à data atual', function (value) {
            if (!value)
                return false;
            const now = new Date();
            const dateFinalEnd = new Date(value);
            dateFinalEnd.setHours(23, 59, 59, 999);
            return dateFinalEnd >= now;
        }),
    }),
});
